import { v2ServicePath } from '../config';

const apiUrl = () => process.env.REACT_APP_API_URL || 'http://localhost:3001';

class WorkflowEvalSuggestionsApiError extends Error {
  constructor(message, status, data = null) {
    super(message);
    this.name = 'WorkflowEvalSuggestionsApiError';
    this.status = status;
    this.data = data;
  }
}

async function safeJson(resp) {
  try {
    return await resp.json();
  } catch {
    return null;
  }
}

async function postJson(url, jwt, body, signal) {
  const opts = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body || {}),
  };
  if (signal) opts.signal = signal;
  const resp = await fetch(url, opts);
  const data = await safeJson(resp);
  if (!resp.ok) {
    throw new WorkflowEvalSuggestionsApiError(data?.error || `HTTP ${resp.status}`, resp.status, data);
  }
  return data;
}

function serviceUrl(appId, path, env, range, extra = {}) {
  const qs = new URLSearchParams();
  if (env) qs.set('env', env);
  if (range) qs.set('range', range);
  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  });
  return `${apiUrl()}${v2ServicePath(appId, path)}?${qs.toString()}`;
}

export async function runWorkflowEvalSuggestions(
  appId,
  env,
  range,
  workflowId,
  jwt,
  {
    workflowVersion = 1,
    force = false,
    signal,
  } = {},
) {
  if (!appId || !workflowId) return null;
  const normalizedVersion = Number(workflowVersion) || 1;
  const raw = await postJson(
    serviceUrl(
      appId,
      `/workflows/${encodeURIComponent(workflowId)}/eval-suggestions`,
      env,
      range,
      { workflow_version: normalizedVersion },
    ),
    jwt,
    {
      force,
      range,
      workflow_version: normalizedVersion,
    },
    signal,
  );
  return raw.data || null;
}
